<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="600px"
            transition="dialog-transition"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("user") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-0 mb-2">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex text-xs-center>
                                <img avatar :src="imageUrl" height="50" width="50" v-if="imageUrl"/>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                    :label="`${$t('selectImage')}`"
                                    @click="pickFileClick"
                                    v-model="imageName"
                                    prepend-icon="attach_file"
                                ></v-text-field>
                                <input
                                    type="file"
                                    id="image"
                                    ref="image"
                                    accept="image/*"
                                    style="display: none"
                                    @change="onFilePicked"
                                >
                            </v-flex>
                            <v-flex xs12>
                                <v-combobox
                                    v-model="company"
                                    :items="companyNames"
                                    :label="`${$t('company')} *`"
                                ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="lastName"
                                    :label="`${$t('lastName')} *`"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="firstName"
                                    :label="`${$t('firstName')} *`"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-text-field
                                    v-model="middleName"
                                    :label="$t('middleName')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="eMail"
                                    :label="`${$t('eMail')} *`"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password1"
                                    :label="`${$t('password')}`"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                    v-model="password2"
                                    :label="`${$t('passwordConfirm')}`"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small class="ml-2">{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveDataClick">{{ $t("save") }}</v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditUserDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog: false,
                dataUpdated: false,
                companies: [],
                companyNames: [],
                company: "",
                userId: 0,
                eMail: "",
                firstName: "",
                lastName: "",
                middleName: "",
                password1: "",
                password2: "",
                imageFile: "",
                imageName: "",
                imageUrl: "",

                dialogWatcher: null
            }
        },

        mounted () {
            this.loadCompanies();
        },

        watch: {
            /* При показе формы сбрасываем флаг изменения данных */
            dialog: function (val) {
                if (val) { this.dataUpdated = false; }
            }
        },

        methods: {
            /**
             * Загрузка списка компаний
             */
            loadCompanies () {
                this.axios.get(
                    this.$store.getters.user.role == 3 ? `${this.$config.apiURL}companies/` : `${this.$config.apiURL}companies/${this.$store.getters.user.company.id}/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        this.$store.getters.user.role == 3 ? this.companies = response.data.companies : this.companies.push(response.data.company);
                    }
                    this.companyNames = [];

                    let dialog = this;

                    this.companies.forEach((item) => {
                        dialog.companyNames.push(item.Name);
                    });

                })
                .catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `EditUserDialog.vue -> loadCompanies: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });
                });
            },

            /**
             * Обработчик выбора файла
             *
             * @param {object} evt Объект-описание события
             */
            onFilePicked (evt) {
                const files = evt.target.files;
                if (files[0] !== undefined) {
                    this.imageName = files[0].name;

                    if (this.imageName.lastIndexOf(".") <= 0) {
                        return;
                    }

                    const fr = new FileReader ();

                    fr.readAsDataURL(files[0]);

                    fr.addEventListener("load", () => {
                        this.imageUrl  = fr.result;
                        this.imageFile = files[0]; // файл с изображением, который может быть загружен на сервер
                    })
                } else {
                    this.imageName = "";
                    this.imageFile = "";
                    this.imageUrl  = "";
                }
            },

            /**
             * Обработчик нажатия на кнопку выбора файла
             */
            pickFileClick () {
                this.$refs.image.click();
            },

            /**
             * Сброс значений формы
             */
            resetForm () {
                this.userId     = 0;
                this.eMail      = "";
                this.firstName  = "";
                this.middleName = "";
                this.lastName   = "";
                this.company    = "";
                this.password1  = "";
                this.password2  = "";
            },

            /**
             * Сохранение данных нового пользователя
             */
            saveData () {
                let companyId  = null;

                this.companies.forEach((company) => {
                    if (company.Name == this.company) {
                        companyId = company.id;
                    }
                });

                let formData = new FormData();

                formData.append("file",       this.imageFile);
                //formData.append("imageFile", this.imageFile);
                formData.append("firstName",  this.firstName);
                formData.append("middleName", this.middleName);
                formData.append("lastName",   this.lastName);
                formData.append("eMail",      this.eMail);
                formData.append("password",   this.password1);
                formData.append("companyId",  companyId);

                this.axios({
                    method: "post",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    url: `${this.$config.apiURL}users/`,
                    data: formData,
                    withCredentials: true
                }).then(response => {
                    if (response.data.status == "attention") {
                        if (response.data.message == "subscriptionLimitReached") {
                            this.showMessageBox(this.$t("attention"), this.$t("createUsersLimitReachedMessage"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantCreateUser"));
                        }
                        this.dataUpdated = false;
                    } else {
                        this.showMessageBox(this.$t("information"), this.$t("userCreated"));
                        this.dataUpdated = true;
                    }
                }).catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `EditUserDialog.vue -> saveData: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantCreateUser") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantCreateUser") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantCreateUser"));
                    }
                });

                this.dialog = false;
            },

            /**
             * Сохранение данных пользователя
             */
            saveDataClick () {
                if (this.userId == 0) {
                    this.saveData();
                } else {
                    this.updateData();
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Обновление данных существующего пользователя
             */
            updateData () {
                let companyId  = null;

                this.companies.forEach((company) => {
                    if (company.Name == this.company) {
                        companyId = company.id;
                    }
                });

                let formData = new FormData();

                formData.append("file",       this.imageFile);
                //formData.append("imageFile", this.imageFile);
                formData.append("firstName",  this.firstName);
                formData.append("middleName", this.middleName);
                formData.append("lastName",   this.lastName);
                formData.append("eMail",      this.eMail);
                formData.append("password",   this.password1);
                formData.append("companyId",  companyId);
                formData.append("userId",     this.userId)

                this.axios({
                    method: "patch",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    url: `${this.$config.apiURL}users/${this.userId}/`,
                    data: formData,
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);

                    //this.showMessageBox(this.$t("information"), this.$t("userUpdated"));
                    this.dataUpdated = true;
                }).catch(err => {
                    this.showMessageBox(this.$t("error"), this.$t("cantUpdateUser"));

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `EditUserDialog.vue -> updateData: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });
                });

                this.dialog = false;
            }
        }
    }
</script>
